module.exports = __webpack_public_path__ + "static/partner5-84bebf1bf655a6afafc29e315910511c.png";